export const NAVIGATE_AUTH = {
    AUTH: "/auth",
    LOGIN: "/login",
    LOGOUT: "/logout",
    REGISTER: "/register",
    FORGOT_PASSWORD: "/forgot-password",
    RESET_PASSWORD: "/reset-password",
    get LOGIN_PAGE() { return `${this.AUTH}${this.LOGIN}`; },
    get LOGOUT_PAGE() { return `${this.AUTH}${this.LOGOUT}`; },
    get RESET_PASSWORD_PAGE() { return `${this.AUTH}${this.RESET_PASSWORD}`; },
}
export const USER_TYPE = {
    GUEST: "",
    REGISTER:"",
    ADMIN: '/admin',
}

export const NAVIGATE_ADMIN = {
    CAMPAIGN:'/campaign',
    CAMPAIGN_CREATE:'/campaign/create',
    CAMPAIGN_DETAIL:'/campaign/detail',
    CAMP_KPI_LIST:'/campaign/kpi-list',
    CONSULTATIONS :'/consultations',
    OPD_CONSULTATIONS :'/opd-consultations',
    BENEFICIARY:'/beneficiaries',
    BENEFICIARY_DETAIL:'/beneficiaries/detail',
    SCHEMS:'/scheme-referal',
    ABHA_CARD:'/abha-application',
    REFERAL_HOSPITAL: '/hospital-referal',
    REFERAL_HOSPITAL_LIST: '/hospital-referral',
    REFERRAL_LIST:'/referral-list',
    PRE_REG :'/pre-registration',
    USER_LIST: '/users',
    CHECK_IN: '/counter-registration',
    PENDING_ACTIONS: '/pending-actions',
    NGO_DASHBOARD: '/ngo-dashboard',
    MEDICIN_LIST: '/medicines',
    HLL_BLOOD_TEST:'/blood-test',
    PHARMACY :'/pharmacy',
    MMHS :'/mmhs',

    ROLES_MASTER: "/master/roles",
    MENU_MASTER: "/master/menu",
    PERMISSION_MASTER: "/master/menu/permission",
    WORKFLOW_MASTER: "/master/workflow",
    
    CAMP_DOCUMENTS: '/camp-documents',
    SCHEME_LIST: '/master/scheme-list',
    CAMP_QUE_ADD:'/jatra-questions',
    JATRA_CREATE: '/jatra/create',
    CAMP_REPORT:'/camp-report',

    SUERVEY_QUESTIONS:'/master/survey-questions',
    SUERVEY_ANSWERS:"/survey-list",
    BHAJANI_MANDAL_LIST:"/bhajani-mandal-list",
    get CAMPAIGN_DETAILS_PAGE() { return `${USER_TYPE.ADMIN}${this.CAMPAIGN_DETAIL}`; },
    get MMHS_PAGE() { return `${USER_TYPE.ADMIN}${this.MMHS}`; },
    get CHECK_IN_PAGE() { return `${USER_TYPE.ADMIN}${this.CHECK_IN}`; },
    get PENDING_ACTIONS_PAGE() { return `${USER_TYPE.ADMIN}${this.PENDING_ACTIONS}`; },
    get REFERAL_HOSPITAL_PAGE() { return `${USER_TYPE.ADMIN}${this.REFERAL_HOSPITAL}`; },
    get REFERRAL_LIST_PAGE() { return `${USER_TYPE.ADMIN}${this.REFERRAL_LIST}`; },
    get SCHEMS_PAGE() { return `${USER_TYPE.ADMIN}${this.SCHEMS}`; },
    get ABHA_CARD_PAGE() { return `${USER_TYPE.ADMIN}${this.ABHA_CARD}`; },
    get CONSULTATIONS_PAGE() { return `${USER_TYPE.ADMIN}${this.CONSULTATIONS}`; },
    get OPD_CONSULTATIONS_PAGE() { return `${USER_TYPE.ADMIN}${this.OPD_CONSULTATIONS}`; },
    get BENEFICIARY_PAGE() { return `${USER_TYPE.ADMIN}${this.BENEFICIARY}`; },
    get BENEFICIARY_LIST_PAGE() { return `${USER_TYPE.ADMIN}${this.BENEFICIARY}`; },
    get HLL_BLOOD_TEST_PAGE() { return `${USER_TYPE.ADMIN}${this.HLL_BLOOD_TEST}`; },
    get PHARMACY_PAGE() { return `${USER_TYPE.ADMIN}${this.PHARMACY}`; },

    get CAMPAIGN_LIST_PAGE() { return `${USER_TYPE.ADMIN}${this.CAMPAIGN}`; },
    get CAMPAIGN_CREATE_PAGE() { return `${USER_TYPE.ADMIN}${this.CAMPAIGN_CREATE}`; },
    get CAMPAIGN_DETAIL_PAGE() { return `${USER_TYPE.ADMIN}${this.CAMPAIGN_DETAIL}`; },
    get CAMP_KPI_LIST_PAGE() { return `${USER_TYPE.ADMIN}${this.CAMP_KPI_LIST}`; },
    get USER_LIST_PAGE() { return `${USER_TYPE.ADMIN}${this.USER_LIST}`; },
    get BENEFICIARY_DETAIL_PAGE() { return `${USER_TYPE.ADMIN}${this.BENEFICIARY_DETAIL}`; },

    get ROLES_MASTER_PAGE() { return `${USER_TYPE.ADMIN}${this.ROLES_MASTER}`; },
    get MENU_MASTER_PAGE() { return `${USER_TYPE.ADMIN}${this.MENU_MASTER}`; },
    get PERMISSION_MASTER_PAGE() { return `${USER_TYPE.ADMIN}${this.PERMISSION_MASTER}`; },
    get WORKFLOW_MASTER_PAGE() { return `${USER_TYPE.ADMIN}${this.WORKFLOW_MASTER}`; },

    get BHAJANI_MANDAL_LIST_PAGE() { return `${USER_TYPE.ADMIN}${this.BHAJANI_MANDAL_LIST}`; },

}

export const NAVIGATE_GUEST = {
    HOME: '/home',
    PRE_REGISTER: '/pre-register',
    GUEST_CAMPAIGN_DETAILS: '/guest-campaigns-details',
    SCHEME_DETAILS: '/scheme-details',
    SUREVEY_FORM: '/survey-form',
    BHAJANI_MANDAL:'/bhajani-mandal',
    JATRA_REGISTER:'/register-jatra',
    TERMS_CONDITIONS: '/terms-conditions',
    PRIVACY_POLICY: '/privacy-policy',
    COPYRIGHT_POLICY: '/copyright-policy',
    DISCLAIMER: '/disclaimer',
    HYPERLINK_POLICY: '/hyperlink-policy',
    INAUGRATION_PAGE: '/inauguration',
    SLIDER: '/slider',
    get HOME_PAGE() { return `${USER_TYPE.GUEST}${this.HOME}`; },
    get  GUEST_CAMPAIGN_DETAILS_PAGE() { return `${USER_TYPE.GUEST}${this.GUEST_CAMPAIGN_DETAILS}`; },
    get PRE_REGISTER_PAGE() { return `${USER_TYPE.GUEST}${this.PRE_REGISTER}`; },
}

export const NAVIGATE_DASHBOARDS = {
    DASHBOARD: '/camp-dashboard',
    OTHER_DASHBOARD: '/dashboard',
    BENEFICIARY_DASHBOARD: '/beneficiary-dashboard',
    JATRA_DASHBOARD: '/jatra-dashboard',
    SURVEY_DASHBOARD: '/survey-dashboard',
    SURVEY_POLICY_DASHBOARD: '/survey-policy-dashboard',
    DASHBOARD_LIST: '/dashboard-list',
    DASHBOARD_HOSPITAL_LIST: '/dashboard-hospital-list',
    EYE_CAMP_DASHBOARD: '/eye-camp/dashboard',
    get EYE_CAMP_DASHBOARD_PAGE() { return `${USER_TYPE.ADMIN}${this.EYE_CAMP_DASHBOARD}`; },
    ///admin/camp-report
    get DASHBOARD_HOSPITAL_LIST_PAGE() { return `${USER_TYPE.ADMIN}${this.DASHBOARD_HOSPITAL_LIST}`; },
    get DASHBOARD_LIST_PAGE() { return `${USER_TYPE.ADMIN}${this.DASHBOARD_LIST}`; },
    get JATRA_DASHBOARD_PAGE() { return `${USER_TYPE.ADMIN}${this.JATRA_DASHBOARD}`; },
    get BENEFICIARY_DASHBOARD_PAGE() { return `${USER_TYPE.GUEST}${this.BENEFICIARY_DASHBOARD}`; },
    get DASHBOARD_PAGE() { return `${USER_TYPE.ADMIN}${this.DASHBOARD}`; },
    get OTHER_DASHBOARD_PAGE() { return `${USER_TYPE.ADMIN}${this.OTHER_DASHBOARD}`; },
    get SURVEY_DASHBOARD_PAGE() { return `${USER_TYPE.ADMIN}${this.SURVEY_DASHBOARD}`; },
    get SURVEY_POLICY_DASHBOARD_PAGE() { return `${USER_TYPE.ADMIN}${this.SURVEY_POLICY_DASHBOARD}`; },
}
